"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerContextTypeEnum = exports.WorkflowOriginEnum = exports.WorkflowTypeEnum = exports.WorkflowCreationSourceEnum = void 0;
const channel_1 = require("./channel");
var WorkflowCreationSourceEnum;
(function (WorkflowCreationSourceEnum) {
    WorkflowCreationSourceEnum["TEMPLATE_STORE"] = "template_store";
    WorkflowCreationSourceEnum["EDITOR"] = "editor";
    WorkflowCreationSourceEnum["NOTIFICATION_DIRECTORY"] = "notification_directory";
    WorkflowCreationSourceEnum["ONBOARDING_DIGEST_DEMO"] = "onboarding_digest_demo";
    WorkflowCreationSourceEnum["ONBOARDING_IN_APP"] = "onboarding_in_app";
    WorkflowCreationSourceEnum["EMPTY_STATE"] = "empty_state";
    WorkflowCreationSourceEnum["DROPDOWN"] = "dropdown";
    WorkflowCreationSourceEnum["ONBOARDING_GET_STARTED"] = "onboarding_get_started";
    WorkflowCreationSourceEnum["BRIDGE"] = "bridge";
    WorkflowCreationSourceEnum["DASHBOARD"] = "dashboard";
})(WorkflowCreationSourceEnum || (exports.WorkflowCreationSourceEnum = WorkflowCreationSourceEnum = {}));
var WorkflowTypeEnum;
(function (WorkflowTypeEnum) {
    WorkflowTypeEnum["REGULAR"] = "REGULAR";
    WorkflowTypeEnum["ECHO"] = "ECHO";
    WorkflowTypeEnum["BRIDGE"] = "BRIDGE";
})(WorkflowTypeEnum || (exports.WorkflowTypeEnum = WorkflowTypeEnum = {}));
var WorkflowOriginEnum;
(function (WorkflowOriginEnum) {
    WorkflowOriginEnum["NOVU_CLOUD"] = "novu-cloud";
    WorkflowOriginEnum["NOVU_CLOUD_V1"] = "novu-cloud-v1";
    WorkflowOriginEnum["EXTERNAL"] = "external";
})(WorkflowOriginEnum || (exports.WorkflowOriginEnum = WorkflowOriginEnum = {}));
var TriggerContextTypeEnum;
(function (TriggerContextTypeEnum) {
    TriggerContextTypeEnum["TENANT"] = "tenant";
    TriggerContextTypeEnum["ACTOR"] = "actor";
})(TriggerContextTypeEnum || (exports.TriggerContextTypeEnum = TriggerContextTypeEnum = {}));
